import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, enumField } from './util';

export enum AchievementTypes {
  by_game = 1,
  by_stage
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    alias: 'type',
    value: 'value',
    type: 'type',
  },
  relation: {
    type: enumField(AchievementTypes),
  }
})
export class Achievement extends BaseModel {
  id: number;
  name: string;
  alias: string;
  type: AchievementTypes;
  value: number;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
